import {checkPassport} from '@router/guards/roleGuard'
export default {
    path: '/auditlog',
    component: () => import('@views/AuditLog/Index'),
    beforeEnter: checkPassport,
    children: [
      {
        path: 'index',
        name: 'auditlog.index',
        component: () => import('@/components/AuditLog/AuditLog')
      }
    ]
  }
  